<template>
  <div class="search-list">
    <div v-if="!searchResults.length" class="empty-state grey--text">
      {{ $t('purchaseV2.catalog.noSearchResults') }}
    </div>
    <div v-else class="catalog-content-grid">
      <CatalogVariantCard
        v-for="variant in searchVariants"
        :key="`variant-${variant.id}`"
        :variant="variant"
        :is-coins-variant="isCoinsVariant(variant)"
        :is-digital-item="isDigitalItem(variant)"
        :arena-currency="arenaCurrency"
        :quantity="getVariantQuantity(variant)"
        @update-quantity="$emit('variant-quantity-change', $event)" />
      <CatalogPromotionCard
        v-for="promotion in searchPromotions"
        :key="`promotion-${promotion.id}`"
        :promotion="promotion"
        :variants="allVariants"
        :arena-currency="arenaCurrency"
        :quantity="getPromotionQuantity(promotion)"
        @update-quantity="$emit('promotion-quantity-change', $event)" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CatalogVariantCard from './VariantCard.vue'
import CatalogPromotionCard from './PromotionCard.vue'

export default {
  name: 'SearchList',
  components: {
    CatalogVariantCard,
    CatalogPromotionCard,
  },
  props: {
    searchResults: { type: Array, default: () => [] },
    allVariants: { type: Array, default: () => [] },
    arenaCurrency: { type: Object, default: () => ({}) },
  },
  computed: {
    ...mapGetters('cart', ['cartItems']),
    searchVariants() {
      return this.searchResults
        .filter((item) => item.type === 'variant')
        .map((item) => item.data)
    },
    searchPromotions() {
      return this.searchResults
        .filter((item) => item.type === 'promotion')
        .map((item) => item.data)
    },
  },
  methods: {
    getVariantQuantity(variant) {
      const selectedVariant = this.cartItems.find(
        (item) => item.type === 'variant' && item.variant.id === variant.id,
      )
      if (!selectedVariant || selectedVariant.type !== 'variant') return 0
      return selectedVariant.quantity
    },
    getPromotionQuantity(promotion) {
      const selectedPromotion = this.cartItems.find(
        (item) =>
          item.type === 'promotion' && item.promotion.id === promotion.id,
      )
      if (!selectedPromotion || selectedPromotion.type !== 'promotion') return 0
      return selectedPromotion.quantity
    },
    isCoinsVariant(variant) {
      return variant?.category?.code === 'CNS'
    },
    isDigitalItem(variant) {
      const code = variant?.category?.code
      return code === 'CNS' || code === 'PAS'
    },
  },
}
</script>

<style scoped>
.search-list {
  width: 100%;
}

.catalog-content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  padding-bottom: 0.5rem;
}

.empty-state {
  text-align: center;
  margin-top: 1rem;
}

/* Responsive breakpoints */
@media (min-width: 600px) {
  .catalog-content-grid {
    gap: 1.25rem;
  }
}

/* 2 columns for medium screens */
@media (min-width: 1080px) {
  .catalog-content-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

/* 3 columns for large screens */
@media (min-width: 1500px) {
  .catalog-content-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }
}
</style>
